//Third party packages
import { Form, InputGroup } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';

import './TextInput.scss';

const TextInput = ({
  prepend = null,
  append = null,
  inputProps,
  label = null,
  parentClassName = null,
  footerLabel = null,
  isRequired = false,
  feedBackMessage = null,
  ariaInvalid = null,
  ariaDescribedby = null,
  loader = null,
  loaderText = null,
}) => (
  <div className="generic-text-input-wrapper">
    {label && (
      <label className="form-label" htmlFor={inputProps.id}>
        {label}
        {isRequired && (
          <span aria-hidden={true} className="mandatory-field">
            *
          </span>
        )}
      </label>
    )}

    <InputGroup
      className={parentClassName && `input-box-generic ${parentClassName}`}
    >
      {prepend && <InputGroup.Prepend>{prepend}</InputGroup.Prepend>}

      <Form.Control
        {...inputProps}
        aria-required={isRequired}
        aria-invalid={ariaInvalid}
        aria-describedby={ariaDescribedby}
        isInvalid={!parentClassName && inputProps?.isInvalid}
      />

      {append && <InputGroup.Append>{append}</InputGroup.Append>}
    </InputGroup>

    {footerLabel && <label className="m-0">{footerLabel}</label>}

    {feedBackMessage && (
      <Form.Control.Feedback
        id={ariaDescribedby}
        type="invalid"
        role="alert"
        aria-live="polite"
        className={feedBackMessage ? 'input-field-feedback' : ''}
      >
        {feedBackMessage}
      </Form.Control.Feedback>
    )}

    {loader && (
      <Loader active size="large" className="font-weight-bold loader-color">
        {loaderText}
      </Loader>
    )}
  </div>
);

export default TextInput;
